import { render, staticRenderFns } from "./DrugType.vue?vue&type=template&id=62690676&scoped=true&"
import script from "./DrugType.vue?vue&type=script&lang=js&"
export * from "./DrugType.vue?vue&type=script&lang=js&"
import style0 from "./DrugType.vue?vue&type=style&index=0&id=62690676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62690676",
  null
  
)

export default component.exports